// utils/socket/createSocketConnection.js
import { io } from 'socket.io-client';
import config from '../../utils/config/config';


export const createSocketConnection = (sessionId) => {
  const headers = { sessionId };

  const socketParams = {
    transports: ['polling', 'websocket'],
    extraHeaders: headers,
    transportOptions: {
      polling: { extraHeaders: headers },
      websocket: { extraHeaders: headers },
    },
    path: '/grpc/clientConn',
    reconnection: Boolean(sessionId),
    withCredentials: true,
    pingTimeout: 40000,
    pingInterval: 35000,
  };

  const socket = io(config.gRPCURL, socketParams);
  return socket;
};